import styled from "@emotion/styled"
import Link from "next/link"
import { AdobeIcon, PdfIcon } from "ui/icons"

import { LayoutContext } from "contexts/LayoutProvider"
import { useContext } from "react"
import colors from "theme/colors"
import { Accordion, NewText, TitleWithLine, useIsDesktop } from "ui"
import { extractProperty } from "utils"
import { getUmbracoMediaUrl } from "utils/utils"

const StyledFilesDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1.5px solid ${colors.black};
  padding-bottom: 32px;
  padding-left: 20px;
  padding-right: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 0px;
    padding-right: 0px;
  }
`
const StyledFilesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid rgba(21, 62, 105, 0.3);
  padding: 24px 12px 12px 12px;
  svg {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  width: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-left: 30px;
    width: auto;
    p {
      width: 145px;
    }
    svg {
      width: 24px;
      height: 24px;
    }
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    svg {
      width: 36px;
      height: 36px;
    }
  }
`

const StyledFilesContainer = styled.div`
  padding-top: 40px;
  padding-bottom: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 60px;
    padding-bottom: 60px;
    padding-left: 146px;
    padding-right: 146px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-top: 80px;
    padding-bottom: 80px;
    padding-left: 220px;
    padding-right: 220px;
  }
`

const StyledTitleWrapper = styled.div`
  ${(props) => props.theme.breakpoints.down("sm")} {
    padding-left: 28px;
    padding-right: 28px;
  }
  margin-bottom: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-bottom: 28px;
  }
  ${(props) => props.theme.breakpoints.down("lg")} {
    margin-bottom: 40px;
  }
`

const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  width: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: auto;
  }
`

function PazomatFiles({ data }: { data: any }) {
  const isDesktop = useIsDesktop()
  const accordions = extractProperty(data, "accordions")
  const { GRAPHQL_URL } = useContext(LayoutContext)

  return (
    <StyledFilesContainer>
      <StyledTitleWrapper>
        <TitleWithLine
          title="טפסים ואישורים"
          titleFontSize={isDesktop ? 64 : 32}
          titleColor={colors.black}
        />
      </StyledTitleWrapper>

      {accordions.map((item: any, index: number) => {
        const accordionTitle = extractProperty(item, "accordionTitle")
        const selectFile = extractProperty(item, "selectFile")

        return (
          <Accordion title={accordionTitle} index={index} key={index}>
            <StyledFilesDiv>
              {selectFile.map((file: any, key: number) => {
                const insertFile = extractProperty(file, "insertFile")
                const selectFileType = extractProperty(file, "selectFileType")
                return (
                  <StyledLink
                    href={getUmbracoMediaUrl(insertFile[0].url, GRAPHQL_URL)}
                    key={key.toString()}
                    target="blank"
                    aria-label={`טפסים ואישורים ${insertFile[0].name} ${selectFileType === "PDF" ? "PDF" : ""}`}
                  >
                    <StyledFilesWrapper>
                      {selectFileType === "PDF" ? <PdfIcon /> : <AdobeIcon />}
                      <NewText
                        component="p"
                        desktopFontSize={16}
                        desktopFontWeight={500}
                        color={colors.blue}
                        smallDesktopFontSize={12}
                        smallDesktopLineHeight="18px"
                        mobileFontSize={14}
                      >
                        {insertFile[0].name}
                      </NewText>
                    </StyledFilesWrapper>
                  </StyledLink>
                )
              })}
            </StyledFilesDiv>
          </Accordion>
        )
      })}
    </StyledFilesContainer>
  )
}
export default PazomatFiles
